<template>
  <div class="col-12 my-2">
    <b-row>
      <b-col class="header_exercise">
        <b-row>
          <b-col class="col-12 col-sm-6 d-flex align-items-center">
            <div class="float-left">
              <b class="">{{ title }}</b>
              <b
                class="badge badge-pill badge-primary fontSize-15 mx-1"
                v-if="showTotals && totalRows"
              >
                {{ totalRows }}</b
              >
            </div>
          </b-col>
          <b-col class="col-12 col-sm-6">
            <div class="float-right">
              <slot name="headerButtons"></slot>
              <b-button
                class="btn-lightgray ml-2"
                @click="addItem"
                v-if="
                  buttons &&
                  buttons.includes('add') &&
                  show_add &&
                  isAdmin(permissions, ['admin'])
                "
                v-b-tooltip.hover
              >
                <mdicon name="plus" size="20" />
              </b-button>

              <b-button
                class="btn-lightgray ml-2"
                v-b-tooltip.hover
                title="به‌روز رسانی لیست"
                @click="!loadingItem && getItems()"
              >
                <mdicon name="refresh" size="20" />
              </b-button>
              <button
                v-if="filterCatch && Object.values(paramsPage).length > 0"
                type="button"
                class="btn btn-danger mx-2 position-relative"
                @click="deleteFilterCacheResource"
                v-b-tooltip.hover
                :title="`پاک کردن فیلتر`"
              >
                <mdicon
                  name="filter-remove-outline"
                  size="24"
                  class="cursor_pointer"
                />
              </button>
              <button
                type="button"
                class="btn btn-lightgray ml-2 position-relative"
                v-if="filterHeaders.length > 0"
                @click="showFilter"
              >
                <span
                  class="badge badge-pill badge-danger position-badge"
                  v-if="Object.values(paramsData).length"
                  >{{ Object.values(paramsData).length }}</span
                >
                <mdicon name="filter-outline" size="20" />
              </button>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <div>
      <b-overlay rounded="sm" :opacity="0.5">
        <div class="text-center" v-show="loadingItem">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
        <template v-slot:overlay>
          <div position-absolute>
            <i class="fa fa-clock-od fa-6x" style="font-size: 48px"></i>
          </div>
        </template>
        <b-row class="justify-content-start min-height-filter">
          <FilterBox
            v-if="filter"
            ref="advanceFilter"
            :headers="filterHeaders"
            @getFilterItems="getFilterItems"
            @getFilterDate="getFilterDate"
            @closeAdvanceFilter="showFilter"
          />
          <b-col v-if="items.length" cols="12">
            <div v-if="componentName == `search-title`" v-show="!loadingItem">
              <b-card v-for="(item, index) in items" :key="index" class="my-1">
                <div slot="header">
                  <b-row>
                    <div class="col-6">
                      <b>{{ $lang.azmoonLang.number_title_question }} </b
                      >{{ item.id }}
                    </div>
                    <div class="col-6">
                      <div class="d-flex justify-content-end">
                        <div
                          class="dynamicButtonGenerated"
                          v-for="(button, index) in availableButtons()"
                          :key="index"
                        >
                          <a
                            class="ml-3 dynamic-buttons"
                            @click="button.click(item)"
                          >
                            <span
                              class="cursor-pointer"
                              v-b-tooltip.hover
                              :title="button.text"
                            >
                              <i :class="button.iconFont"></i>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </b-row>
                </div>
                <div v-html="createPureDom(item.title_description)"></div>
              </b-card>
            </div>
            <div v-if="componentName == `search-option`">
              <b-card
                v-for="(item, index) in items"
                :key="index"
                class="my-1"
                v-show="!loadingItem"
              >
                <div slot="header">
                  <b-row>
                    <div class="col-6">
                      <b>{{ $lang.option_number }} </b> {{ item.id }}
                    </div>
                    <div class="col-6">
                      <div class="d-flex justify-content-end">
                        <div
                          class="dynamicButtonGenerated"
                          v-for="(button, index) in availableButtons()"
                          :key="index"
                        >
                          <div class="ml-3 dynamic-buttons">
                            <div
                              @click="button.click(item)"
                              v-if="button"
                              class="list-unstyled cursor-pointer"
                              v-b-tooltip.hover.bottom
                              :title="button.text"
                            >
                              <span :class="button.iconFont"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-row>
                </div>
                <div v-html="createPureDom(item.option_description)" />
                <div class="m-auto text-center">
                  <img v-if="item.url" :src="item.url" class="w-25" />
                </div>
              </b-card>
            </div>
            <div v-if="componentName == `search-question` || !componentName">
              <b-row
                v-for="(item, key) in items"
                :key="key"
                class="my-2"
                v-show="!loadingItem"
              >
                <b-col class>
                  <b-card class="card_exercise">
                    <div slot="header">
                      <b-row>
                        <div class="col-12 col-md-10 float-left">
                          <div v-if="!item.question_order">
                            <div v-if="show_checkbox">
                              <b-form-checkbox
                                v-model="item.checked"
                                :id="`checkbox-${key}`"
                                :name="`checkbox-${key}`"
                                value="true"
                                unchecked-value="false"
                                @change="
                                  changeValue(item.question_info, $event)
                                "
                              >
                                {{
                                  item.question_info && item.question_info.id
                                }})
                              </b-form-checkbox>
                            </div>
                            <div v-else>
                              {{ item.question_info && item.question_info.id }})
                            </div>
                          </div>
                          <div v-if="item.question_number">
                            <strong
                              v-b-tooltip.hover
                              :title="
                                item.question_info && item.question_info.id
                              "
                              >{{ item.question_number }} )</strong
                            >
                          </div>
                        </div>

                        <div class="col-12 col-md-2">
                          <div
                            class="d-flex justify-content-end"
                            v-if="showBtn"
                          >
                            <slot
                              name="addBtnQuestion"
                              v-bind:item="item"
                            ></slot>
                            <div
                              class="dynamicButtonGenerated"
                              v-for="(button, index) in availableButtons()"
                              :key="index"
                            >
                              <a
                                class="ml-3 dynamic-buttons"
                                @click="button.click(item)"
                              >
                                <span
                                  class="cursor-pointer"
                                  v-b-tooltip.hover
                                  :title="button.text"
                                >
                                  <i :class="button.iconFont"></i>
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </b-row>
                    </div>
                    <b-row>
                      <div class="col-12 col-md-12">
                        <div
                          v-if="
                            item.question_info.display_mode &&
                            item.question_info.display_mode.id == 1
                          "
                        >
                          <div
                            v-html="
                              createPureDom(
                                pathOr(
                                  '',
                                  [
                                    'question_info',
                                    'title',
                                    'title_description',
                                  ],
                                  item
                                )
                              )
                            "
                          ></div>
                        </div>
                      </div>
                    </b-row>

                    <hr
                      v-if="
                        pathOr([], ['question_info', 'options'], item).length ||
                        pathOr(false, ['question_info', 'correct_answer'], item)
                      "
                    />
                    <b-col
                      cols="12"
                      v-if="
                        pathOr([], ['question_info', 'options'], item).length
                      "
                    >
                      <div
                        v-if="
                          pathOr(
                            null,
                            ['question_info', 'display_mode', 'id'],
                            item
                          ) === 1
                        "
                        :class="{
                          row: includes(
                            pathOr(
                              null,
                              ['question_info', 'display_style', 'id'],
                              item
                            ),
                            [1, 3]
                          ),
                        }"
                      >
                        <optionchecked
                          v-for="(option, index) in item.question_info &&
                          item.question_info.options"
                          :key="index"
                          :option="option"
                          :col_number="
                            item.question_info &&
                            item.question_info.display_count
                          "
                          :option_show_kind="
                            item.question_info &&
                            item.question_info.option_show_kind &&
                            item.question_info.option_show_kind.id
                          "
                          :display_style="
                            item.question_info &&
                            item.question_info.display_style &&
                            item.question_info.display_style.id
                          "
                        />
                      </div>
                      <lineOption
                        v-if="
                          item.question_info.display_mode &&
                          item.question_info.display_mode.id == 2
                        "
                        :option_show_kind="
                          item.question_info.option_show_kind &&
                          item.question_info.option_show_kind.id
                        "
                        :title="
                          item.question_info.title &&
                          item.question_info.title.title_description
                        "
                        :options="
                          item.question_info && item.question_info.options
                        "
                        class="m-0"
                      />
                    </b-col>

                    <div
                      v-if="
                        pathOr(false, ['question_info', 'correct_answer'], item)
                      "
                    >
                      {{
                        `${$lang.question_answer} : ${pathOr(
                          false,
                          ["question_info", "correct_answer"],
                          item
                        )}`
                      }}
                    </div>

                    <template #footer>
                      <b-row class="mb-2">
                        <div class="ml-3">
                          <!-- <strong>{{$lang.refrences}}</strong> -->
                        </div>
                        <template>
                          <div
                            v-if="
                              item.question_info &&
                              item.question_info.question_kind &&
                              item.question_info.question_kind.caption
                            "
                          >
                            <span
                              v-b-tooltip.hover
                              :title="$lang.question_kind"
                            >
                              <i class="fa fa-circle mr-1"></i
                            ></span>
                            <strong class="badge competency-tag mr-3">
                              {{
                                item.question_info &&
                                item.question_info.question_kind &&
                                item.question_info.question_kind.caption
                              }}
                            </strong>
                          </div>
                          <div
                            class="ml-3"
                            v-if="
                              item.question_info &&
                              item.question_info.question_refrence
                            "
                          >
                            <span
                              v-b-tooltip.hover
                              :title="$lang.question_refrence"
                            >
                              <i class="fa fa-circle mr-1"></i
                            ></span>
                            <strong class="badge competency-tag mr-3">{{
                              item.question_info &&
                              item.question_info.question_refrence &&
                              item.question_info.question_refrence.caption
                            }}</strong>
                          </div>

                          <div
                            v-if="
                              item.question_info &&
                              item.question_info.question_refrence_number
                            "
                          >
                            <span
                              v-b-tooltip.hover
                              :title="$lang.question_refrence_number"
                            >
                              <i class="fa fa-circle mr-1"></i>
                            </span>
                            <strong class="badge competency-tag mr-3">
                              {{
                                item.question_info &&
                                item.question_info.question_refrence_number
                              }}
                            </strong>
                          </div>
                          <div
                            v-if="item.question_info && item.question_info.id"
                          >
                            <span
                              v-b-tooltip.hover
                              :title="$lang.number_resource_question"
                              ><i class="fa fa-circle mr-1"></i
                            ></span>
                            <strong class="badge competency-tag mr-3">
                              {{ item.question_info && item.question_info.id }}
                            </strong>
                          </div>
                          <div
                            class=""
                            v-if="
                              item.question_info &&
                              item.question_info.exam_pack_array
                            "
                          >
                            <span v-b-tooltip.hover :title="$lang.use_exam_pack"
                              ><i class="fa fa-circle mr-1"></i
                            ></span>
                            <strong
                              class="badge competency-tag mr-3 word-break-all"
                            >
                              {{ item.question_info.exam_pack_array }}
                            </strong>
                          </div>
                          <div v-if="item.exam_pack_question_irt">
                            <span
                              v-b-tooltip.hover
                              :title="$lang.azmoonLang.exam_pack_question_irt"
                              ><i class="fa fa-circle mr-1"></i
                            ></span>
                            <strong class="badge competency-tag mr-3">
                              {{ item.exam_pack_question_irt }}
                            </strong>
                          </div>
                        </template>
                      </b-row>
                    </template>
                  </b-card>
                </b-col>
              </b-row>
            </div>
            <paganationSearch
              :allowPaginate="allowPaginate"
              :total="totalRows"
              :total_pages="total_pages"
              :perPage="per_page"
              v-model="page"
              @input="paging"
            />
          </b-col>
          <b-col :class="`text-center col-12 mt-2`" v-else>
            <h4 v-if="!loadingItem">{{ noData }}</h4>
          </b-col>
        </b-row>
      </b-overlay>
    </div>
    <confirm
      :title="modalTitle"
      :description="message"
      v-model="removeModal"
      :ok-title="$lang.yes"
      :cancel-title="$lang.no"
      :loading="removeModalLoading"
      @ok="confirmedRemoveItem"
      @cancel="notConfirmedRemoveItem"
    ></confirm>
  </div>
</template>

<script>
import paganationSearch from "@/components/base/paganationSearch";
import FilterBox from "@/components/global/FilterBox";
import confirm from "@/components/base/confirm";
import lineOption from "@/modules/azmoon/views/preview/lineOption";
import optionchecked from "@/modules/azmoon/views/preview/optionchecked";
import filterMethods from "@/mixin/filterMethods.js";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl } from "@/shared/utils";
import { createPureDom } from "@/shared/utils";

export default {
  name: "question-card",
  extends: filterMethods,
  components: {
    FilterBox,
    confirm,
    optionchecked,
    lineOption,
    paganationSearch,
  },
  props: {
    outParams: {
      type: String,
      default: "",
    },
    allowPaginate: {
      type: Boolean,
      default: true,
    },
    show_checkbox: {
      type: Boolean,
      default: false,
    },
    show_add: {
      type: Boolean,
      default: false,
    },
    showBtn: {
      type: Boolean,
      default: true,
    },
    filterCatch: {
      type: Boolean,
      default: true,
    },
    componentName: {
      type: String,
      default: "",
    },
    questionSelected: {
      type: Array,
      default: () => [],
    },
    showTotals: {
      type: Boolean,
      default: true,
    },
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    dynamicButtons: {
      type: [Array, Function],
      default: () => [],
    },
    isDynamicButtons: {
      type: Boolean,
      default: false,
    },
    editBtnTooltip: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      addModal: false,
      page: 1,
      modalTitle: "",
      message: "",
      noData: "",
      removingItem: null,
      removeModal: false,
      total_pages: 0,
      per_page: 0,
      totalRows: 0,
      permissions: [],
      buttons: [],
      // loadScroll: false,
      showSomeBtn: false,
      permission: [],
      loadingItem: false,
      items: [],
      filterItems: [],
      filterHeaders: [],
      inputSearch: "",
      width: 800,
      columns: [],
      viewCount: 10,
      defaultButtons: [
        {
          id: "2",
          name: "edit", // ویرایش
          iconFont: "fa fa-edit fa-lg  text-success ",
          text: this.editBtnTooltip
            ? this.editBtnTooltip
            : this.$lang.search.edit_tooltip,
          AllowPermissions: ["admin", "edit"],
          click: this.modify,
        },
        {
          id: "3",
          name: "delete", //حذف
          text: this.$lang.search.remove_tooltip,
          iconFont: "fas fa-times  fa-lg text-danger ",
          AllowPermissions: ["admin"],
          click: this.removing,
        },

        {
          id: "4",
          name: "view", //نمایش
          text: this.$lang.show,
          iconFont: "fa fa-eye  fa-lg  text-success",
          AllowPermissions: ["view"],
          click: this.modify,
        },
        {
          id: "7",
          text: this.$lang.clone_question_new,
          name: "clone", //کپی
          iconFont: "fa fa-clone fa-lg text-secondary ",
          click: this.cloneItem,
          AllowPermissions: ["admin"],
        },
      ],
      filter: false,
      paramsPage: {},
      paramsData: {},
      removeModalLoading: false,
    };
  },
  methods: {
    pathOr,
    includes,
    createPureDom,
    isAdmin,
    generateApiUrl,
    addItem() {
      this.$emit("addItem");
    },
    cloneItem(item) {
      this.$emit("cloneItem", item);
    },
    async fillTable() {
      if (this.filterCatch) {
        let params = await this.getFilterCacheResource();
        for (const key in params) {
          if (params.hasOwnProperty.call(params, key)) {
            const element = params[key];
            this.paramsPage[key] = element;
          }
        }
      } else {
        this.paramsPage["page"] = 1;
        this.paramsPage["per_page"] = this.defaultViewCount;
      }
      // this.paramsPage
      await this.getItems();
      return true;
    },
    changeValue(item, event) {
      item.checked = event;
      this.$emit("changeValue", item);
    },
    paging(page) {
      this.paramsPage["page"] = page;
      this.getItems();
    },
    showFilter() {
      this.filter = !this.filter;
    },
    getFirstPageItems() {
      this.page = 1;
      this.loadingItem = true;
      this.getItems();
    },
    getFilteredItems() {
      // زمانی که فیلتر را می زنید این متد صدا زده می شود
      this.page = 1;
      this.loadingItem = true;
      this.getItems()
        .then((items) => {
          this.items = [...items];
        })
        .finally(() => (this.loadingItem = false));
    },
    getItems(updateConfig = true) {
      this.columns = [];
      this.loadingItem = true;

      const { per_page, order_by, page, locale_id, ...otherFilter } =
        this.paramsPage;
      this.paramsData = otherFilter;
      return this.$httpService
        .get(this.url, this.paramsPage)
        .then((response) => {
          this.permissions = response.data.permissions;
          this.genatatePermistionButton(response.data.permissions);

          if (!this.filterHeaders.length > 0) {
            this.filterHeaders = response.data.filters.map((x) => {
              return {
                ...x,
                loader: !x.open,
              };
            });
          }
          this.$emit("getOtherData", pathOr(null, ["data", "other"], response));

          if (response.data.data && "result" in response.data.data) {
            this.totalRows = response.data.data.total;
            this.total_pages = response.data.data.total_pages;
            this.per_page = response.data.data.per_page;
            let items = response.data.data.result;

            if (items.length == 0) {
              this.items = [];
              this.noData = this.$lang.noData;
              return true;
            }
            this.items = items.map((x) => {
              let item = this.questionSelected.find(
                (z) => z.id == x.question_info.id
              );
              if (item) {
                return {
                  checked: true,
                  ...x,
                };
              } else {
                return {
                  checked: false,
                  ...x,
                };
              }
            });
            this.totalRows = response.data.data.total;
            return items;
          } else {
            return [];
          }
        })
        .catch((error) => {
          this.$generateError(error);
          throw error;
        })
        .finally(() => {
          this.loadingItem = false;
          /* در صورتی که جستجو چیزی برنگردانده باشد
                           مقدار فیلتر ستون‌ها خالی است و پس از جستجو کردن و مقدار داشتن، باید دوباره از اول فیلتر ستون‌ها پر شود
                          */
          if (this.columns && this.columns.length)
            if (updateConfig)
              // در صورتی که نیاز به آپدیت کانفیگ باشد، آپدیت شود
              this.updateConfig();
          this.$emit("change", this.items);
        });
    },
    availableButtons() {
      // create buttons
      let generateButtons = [];
      if (this.isDynamicButtons) generateButtons = this.dynamicButtons;
      else generateButtons = this.defaultButtons;
      return generateButtons
        .filter((button) => {
          // compare button permission and user permissions
          let ok = Object.values(this.permissions).filter((x) =>
            button.AllowPermissions.includes(x)
          );
          // compare keys button has and defult button dosent have
          return ok.length > 0;
        })
        .map((but) => {
          let temp = Object.assign({}, but); // clone
          let permission = this.defaultButtons.find((x) => x.name == but.name);
          return {
            ...permission,
            ...temp,
          };
        });
    },
    modify(item) {
      this.$emit("edit_item", item);
    },
    removing(item) {
      let nameId = null;
      if (item.question_info) {
        nameId = `${item.question_info.id} ${
          item.question_info && item.question_info.title
            ? item.question_info.title.title_description
            : ""
        }`;
      } else {
        nameId = `${
          item.title_description
            ? item.title_description
            : item.option_description
        }`;
      }
      this.removingItem = item;
      this.message = this.$lang.are_you_sure_to_remove_item.replace(
        "{item}",
        nameId
      );
      this.modalTitle = this.$lang.remove_item;
      this.removeModal = true;
    },
    notConfirmedRemoveItem() {
      this.removeModal = false;
      this.removingItem = null;
      this.message = "";
    },
    async confirmedRemoveItem() {
      try {
        this.message = "";
        this.removeModalLoading = true;
        let id = this.removingItem.question_info
          ? this.removingItem.question_info.id
          : this.removingItem.id;
        const response = await this.$httpService.delete(this.url + "/" + id);
        this.$notify.success(response.data.message);
        this.items = await this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.removingItem = null;
        this.removeModalLoading = false;
        this.removeModal = null;
      }
    },
    genatatePermistionButton(permitions) {
      if (permitions) {
        if (permitions.includes("admin")) {
          this.buttons = ["add", "delete", "edit", "enable", "view"];
        }
        if (permitions.includes("edit")) {
          this.buttons = ["edit", "enable"];
        }
        if (permitions.includes("view")) {
          this.buttons = ["view"];
        }
      } else {
        this.buttons = [];
      }
    },
  },
  created() {
    this.fillTable();
  },
};
</script>

<style>
.header_exercise {
  background: #f0f3f5;
  padding: 10px;
  border: 1px solid lightgray;
  margin: 0 15px 5px;
}

.card_exercise {
  margin-bottom: 5px;
}

.exercise-details {
  border-radius: 5px 20px 5px;
  background: #cae6fc;
}

.competency-tag {
  background: #4040c8;
  /* background: black; */
  /* color: white; */
  color: white;
  font-weight: 300;
  font-size: 12px;
}

.reference-tag {
  background: #bd40c8;
  color: white;
  font-weight: 300;
  font-size: 12px;
}

.exercise-type {
  color: #4040c8;
}

.algorithm-duration {
  background: #4040c8;
  color: white;
  font-weight: 400;
  font-size: 12px;
}

.total-duration {
  background: #bd40c8;
  color: white;
  font-weight: 400;
  font-size: 12px;
}

.border-competency {
  border-right: 2px solid #bd40c8;
}

.title_description > p {
  padding: 0 !important;
  margin: 0 !important;
}

.title_description > .image > img {
  width: 100%;
}

.my_list_style {
  list-style: decimal;
}

.word-break-all {
  white-space: break-spaces;
  word-break: break-all;
}
</style>
